import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'loyaltic-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})
export class LayoutComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
